<script setup>
import { onUnmounted, ref, watch } from "vue";

const props = defineProps({
    show: {
        type: Boolean,
        default: true,
    },
});

const container = ref();
const confettiColors = ["#FF8E44", "#F91362", "#35126A"];
const confettiAnimations = ["slow", "medium", "fast"];
const interval = ref();

const start = () => {
    interval.value = window.setInterval(() => {
        if (!container.value) return;

        const confettiEl = document.createElement("div");
        const confettiSize = Math.floor(Math.random() * 3) + 7 + "px";
        const confettiBackground = confettiColors[Math.floor(Math.random() * confettiColors.length)];
        const confettiLeft = Math.floor(Math.random() * container.value.offsetWidth) + "px";
        const confettiAnimation = confettiAnimations[Math.floor(Math.random() * confettiAnimations.length)];

        confettiEl.classList.add("confetti", "confetti--animation-" + confettiAnimation);
        confettiEl.style.left = confettiLeft;
        confettiEl.style.width = confettiSize;
        confettiEl.style.height = confettiSize;
        confettiEl.style.backgroundColor = confettiBackground;

        confettiEl.removeTimeout = setTimeout(function () {
            confettiEl.parentNode.removeChild(confettiEl);
        }, 3000);

        container.value.appendChild(confettiEl);
    }, 50);
};

const stop = () => {
    clearInterval(interval.value);
};

watch(
    () => props.show,
    (value) => {
        if (value) {
            start();
        } else {
            stop();
        }
    },
    { immediate: true }
);

onUnmounted(() => {
    stop();
});
</script>

<template>
    <Teleport to="body">
        <div class="otomatic-ai-app">
            <div id="congratulations" ref="container" class="z-[100001] overflow-hidden fixed inset-0 pointer-events-none"></div>
        </div>
    </Teleport>
</template>

<style>
@keyframes confetti-slow {
    0% {
        transform: translate3d(0, 0, 0) rotateX(0) rotateY(0);
    }

    100% {
        transform: translate3d(25px, 105vh, 0) rotateX(360deg) rotateY(180deg);
    }
}

@keyframes confetti-medium {
    0% {
        transform: translate3d(0, 0, 0) rotateX(0) rotateY(0);
    }

    100% {
        transform: translate3d(100px, 105vh, 0) rotateX(100deg) rotateY(360deg);
    }
}

@keyframes confetti-fast {
    0% {
        transform: translate3d(0, 0, 0) rotateX(0) rotateY(0);
    }

    100% {
        transform: translate3d(-50px, 105vh, 0) rotateX(10deg) rotateY(250deg);
    }
}

.confetti {
    position: absolute;
    z-index: 1;
    top: -10px;
    border-radius: 0%;
}

.confetti--animation-slow {
    animation: confetti-slow 4.5s linear 1 forwards;
}

.confetti--animation-medium {
    animation: confetti-medium 3.5s linear 1 forwards;
}

.confetti--animation-fast {
    animation: confetti-fast 2.5s linear 1 forwards;
}
</style>
